import styled from 'styled-components';

export const Container = styled.div`
  max-width: 100%;
  min-width: 0;
`;
